<template>
     <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <!--学生管理-->
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:200px;">
                    <el-cascader
                        :options="depts"
                        v-model="deptId"
                        placeholder="请选择机构名称"
                        :props="props"
                        collapse-tags
                        clearable></el-cascader>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="checkStatus" clearable placeholder="审核状态">
                        <el-option
                            v-for="item in checkStatuss"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="dingTalkBindStatus" clearable placeholder="钉钉绑定状态">
                        <el-option
                            v-for="item in dingTalkBindStatuss"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="name" placeholder="姓名"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="cardNo" placeholder="卡号"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="roomNumber" placeholder="房间号"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="classNo" placeholder="班内学号"></el-input>
                </div>
            </div>
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            
            <div style="display: block; height:40px;float:right;">
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-s-promotion" @click="moveDept()">移动机构</el-button>
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-folder-add" @click="importUser()">导入</el-button>
                <el-button type="primary"  @click="exportExcel">导出Excel</el-button>
                <el-button type="primary"  @click="downloadBatchQrcode">批量二维码</el-button>
                <el-button type="danger"  class="handle-del mr10" icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
                <!-- <el-button type="danger"  class="handle-del mr10" icon="el-icon-delete" @click="batchClear">批量学生头像清空</el-button> -->
                <el-button type="danger"  class="handle-del mr10" icon="el-icon-delete" @click="batchDingUnbind">批量钉钉重绑</el-button>
            </div>

            <el-table
                :data="data"
                style="width:100%;margin-bottom:20px;"
                row-key="id"
                height="550"
                border
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55px" :selectable="permissionControl"></el-table-column>
                <el-table-column type="index" fixed label="序号" width="55px" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="头像"  :show-overflow-tooltip="true" fixed width="70px" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.faceImage != null && scope.row.faceImage != ''">
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.faceImage" lazy="loading" style="max-height:250px; max-width:330px"/>
                                <img slot="reference" :src="scope.row.faceImage"  lazy="loading" style="max-height: 50px;max-width: 130px">
                            </el-popover>
                        </div>
                        <div v-else>
                            未上传
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name"  fixed label="姓名" :show-overflow-tooltip="true" width="70px" >
                    <template slot-scope="scope">
                        <el-link type="primary" @click="showData(scope.row)">{{scope.row.name}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="cardNo" label="卡号" :show-overflow-tooltip="true" width="150px" ></el-table-column>
                <el-table-column prop="personType" label="人员类型" width="80px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.personType == 1">
                            学生
                        </div>
                        <div v-else-if="scope.row.personType == 2">
                            教职
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="classNo" label="班内学号" width="100"></el-table-column>
                <el-table-column prop="checkStatus" label="人员状态" width="80px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.faceImage != null && scope.row.faceImage != ''">
                            <div v-if="scope.row.checkStatus == 0">
                                <span style="color: red;">不通过</span>
                            </div>
                            <div v-else-if="scope.row.checkStatus == 1">待审核</div>
                            <div v-else-if="scope.row.checkStatus == 2">
                                <span style="color: green;">通过</span>
                            </div>
                            <div v-else-if="scope.row.checkStatus == 3">
                                <span style="color: #f6dda4;">复审中</span>
                            </div>
                            <div v-else-if="scope.row.checkStatus == 4">
                                <span style="color: red;">正在删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="钉钉绑定状态" width="80px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.count > 0">
                            <span style="color: green;">已绑定</span>
                        </div>
                        <div v-else-if="scope.row.count == 0">
                            <span style="color: red;">未绑定</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="是否需录入人脸" width="100px">
                    <template slot-scope="scope">
                        {{ isInputFace(scope.row.inputFaceYear, scope.row.updateFaceImageTime) }}
                    </template>
                </el-table-column>
                <el-table-column prop="checkRemark" label="审核备注" :show-overflow-tooltip="true" width="100px"> </el-table-column>
                <el-table-column prop="deptName" label="所属学校" :show-overflow-tooltip="true" width="100px"> </el-table-column>
                <el-table-column prop="deptIdstrName" label="所属机构" :show-overflow-tooltip="true" width="100px"> </el-table-column>
                <el-table-column prop="sex" label="性别"  width="80px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sex == 1">
                            男
                        </div>
                        <div v-else-if="scope.row.sex == 2">
                            女
                        </div>
                        <div v-else>
                            未知
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="studentType" label="学生类型" width="80px"> 
                    <template slot-scope="scope">
                        <div v-if="scope.row.studentType == 0">
                            其他
                        </div>
                        <div v-else-if="scope.row.studentType == 1">
                            寄宿生
                        </div>
                        <div v-else-if="scope.row.studentType == 2">
                            走读生
                        </div>
                        <div v-else-if="scope.row.studentType == 3">
                            寄午生
                        </div>
                        <div v-else-if="scope.row.studentType == 4">
                            艺考生
                        </div>
                        <div v-else-if="scope.row.studentType == 5">
                            休假生
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <span v-if="scope.row.id != 1 && scope.row.personType == 1">
                            <el-button
                                @click.native.prevent="lookVideo(scope.row)"
                                type="text"
                                size="small">
                                <span style="color: #387EE8;">查看人脸视频</span>
                            </el-button>
                            <el-button style="color: #387EE8;"
                                @click.native.prevent="downloadQrcode(scope.row)"
                                type="text"
                                size="small">
                                二维码
                            </el-button>
                            <!-- <el-button style="color: #387EE8;"
                                @click.native.prevent="lookFamily(scope.row.id)"
                                type="text"
                                size="small">
                                家属
                            </el-button> -->
                        </span>
                        <span v-if="permissionControl(scope.row)">
                            <el-button 
                                @click.native.prevent="setUpdate(scope.row)"
                                type="text"
                                size="small">
                                <span style="color: #387EE8;">修改</span>
                            </el-button>
                            <el-button style="color:#387EE8;" v-if="scope.row.checkStatus == 1"
                                @click.native.prevent="checkUser(scope.row.id)"
                                type="text"
                                size="small">
                                审核
                            </el-button>
                            <el-button style="color: #387EE8;"  v-if="scope.row.count > 0"
                                @click.native.prevent="updateDingUnbind(scope.row)"
                                type="text"
                                size="small">
                                钉钉重绑
                            </el-button>
                            <el-button style="color: red"
                                @click.native.prevent="del(scope.row)"
                                type="text"
                                size="small">
                                删除
                            </el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>

        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <!--移动机构 -->
        <div v-if="moveVisible">
            <move ref="move"></move>
        </div>
        <!--审核 -->
        <div v-if="checkVisible">
            <check ref="check"></check>
        </div>
         <!--家属 -->
        <div v-if="familyVisible">
            <family ref="family"></family>
        </div>
        <!--详情 -->
        <div v-if="userDetailsVisible">
            <userDetails ref="userDetails"></userDetails>
        </div>
        <!--导入 -->
        <div v-if="importUserVisible">
            <importUser ref="importUser"></importUser>
        </div>
        <!--查看人脸视频 -->
        <div v-if="uploadVideoVisible">
            <uploadVideo ref="uploadVideo"></uploadVideo>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http';
    import add from './Add.vue';
    import update from './Update.vue';
    import move from '../user/Move.vue';
    import check from '../user/Check.vue';
    import family from '../user/Family.vue';
    import userDetails from '../user/UserDetails.vue';
    import importUser from '../user/ImportUser.vue';
    import uploadVideo from '../user/UploadVideo.vue';

    export default {
        name:"Student",
        data(){
            return{
                loading:false,
                menuName:"",
                loadingText:"",
                addVisible:false,
                updateVisible:false,
                moveVisible:false,
                checkVisible:false,
                familyVisible:false,
                userDetailsVisible:false,
                importUserVisible:false,
                uploadVideoVisible:false,
                props: { multiple: true,  checkStrictly: true },
                common:{
                    total:0,
                    pageSize:30,
                    page:1,
                    isPage:1,
                    allSizes:[30,50,100],
                    checkboxArr:[],
                    checkDeptIdArr:[],
                    checkDataArr:[]
                },
                classNo:"",
                roomNumber:"",
                cardNo:"",
                name:"",
                checkStatus:"",
                dingTalkBindStatus:"",
                currUserId:"",
                userId:"",
                depts:[],
                deptId:[],
                data:[],
                inputFaceYear:"",
                checkStatuss:[{
                    value: '',
                    label: '全部'
                },{
                    value: 0,
                    label: '不通过'
                }, {
                    value: 1,
                    label: '待审核'
                }, {
                    value: 3,
                    label: '复审中'
                }, {
                    value: 2,
                    label: '审核通过'
                }, {
                    value: 4,
                    label: '需录入人脸'
                }],
                dingTalkBindStatuss:[{
                    value: 1,
                    label: '已绑定'
                }, {
                    value: 2,
                    label: '未绑定'
                }],
                headmaster:"",
                classTearcher:"",
                controlClass:"",
                selfDeptId:"",
            }
        },
        components: {
            add,update,move,check,family,userDetails,importUser,uploadVideo
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id;

            this.getDeptCascader();
            this.getData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            selectable(row){
                if(this.currUserId === '1'){
                    return true
                }else{
                    if(row.commonId!=undefined && row.commonId.indexOf(this.currUserId) > -1){
                        return true
                    }else{
                        return false
                    }
                }
            },
            filterDeptOptions(nodes){
                if(!Array.isArray(nodes)){
                    return [];
                }
                let res = [];
                for(let i=0;i<nodes.length;i++){
                    let n = nodes[i];
                    let children = this.filterDeptOptions(n.children);
                    let match = (n.parentId === 0) || (this.$util.isNotEmpty(n.label) && (n.label.indexOf('年级') > -1 || n.label.indexOf('不在班学生组') > -1));
                    if(match || (children && children.length > 0)){
                        res.push(Object.assign({}, n, { children }));
                    }
                }
                return res;
            },
            //部门 
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl;
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.depts = this.filterDeptOptions(res.data.selects);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let deptIdArr=new Array();
                for(let i=0;i<this.deptId.length;i++){
                    let deptId=this.deptId[i];
                   deptIdArr.push(deptId[deptId.length-1]);
                }
                let url  = this.userUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    name:this.name,
                    cardNo:this.cardNo,
                    checkStatus:this.checkStatus,
                    dingTalkBindStatus:this.dingTalkBindStatus,
                    deptId:deptIdArr.join(","),
                    roomNumber:this.roomNumber,
                    classNo:this.classNo,
                    inputFaceYear:this.inputFaceYear,
                    personType:1
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data=res.data.users;
                       this.common.total=res.data.total;
                       this.headmaster = res.data.headmaster;
                       this.classTearcher = res.data.classTearcher;
                       this.controlClass = res.data.controlClass;
                       this.selfDeptId = res.data.selfDeptId;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init("");
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.userId = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                
                this.loading=true;
                this.loadingText="正在删除中...";

                let url = this.userDelUrl;
                let data = {
                    id:this.userId
                };
                this.apiPost(url,data).then((res)=>{
                     this.loading=false;
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            },
            //批量删除
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.userId= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择数据",2);
                }
            },
            // 批量学生头像清空
            batchClear(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.userId= idStr;

                    let msg="请确认是否清空学生头像，恢复默认的卡通头像，是否继续？";
                    this.$commonFn.showConfirm2(msg,this.clearSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择数据",2);
                }
            },
            clearSuccess(){
                
                this.loading=true;
                this.loadingText="正在清空头像中...";

                let url = this.clearFaceImageUrl;
                let data = {
                    ids:this.userId
                };
                this.apiPost(url,data).then((res)=>{
                     this.loading=false;
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            },
            handleSelectionChange(val){
                this.common.checkboxArr = []
                this.common.checkDeptIdArr = []
                this.common.checkDataArr = []
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id)
                    if(!this.common.checkDeptIdArr.includes(val[i].deptId)){
                        this.common.checkDeptIdArr.push(val[i].deptId)
                    }

                    let selectData = {}
                    selectData.name = val[i].name
                    selectData.deptName = val[i].deptName
                    selectData.id = val[i].id
                    this.common.checkDataArr.push(selectData)
                }
            },
            showData(row){
                 this.userDetailsVisible = true;
                this.$nextTick(() => {
                    this.$refs['userDetails'].init(row);
                })
            },
            moveDept(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array()
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i])
                        }
                    }
                    let checkDeptIds = this.common.checkDeptIdArr
                    if(checkDeptIds.length > 1){
                        this.$commonFn.showTip("选中的数据存在多个学校，请选择相同学校的数据进行移动机构",2)
                        return
                    }

                    let ids = checkIdArr.join(",")
                    let deptIds = checkDeptIds.join(",") 
                    this.moveVisible=true
                    this.$nextTick(() => {
                        this.$refs['move'].init(ids, deptIds)
                    })
                }else{
                    this.$commonFn.showTip("请选择数据",2)
                }
            },
            checkUser(id){
                this.checkVisible = true;
                this.$nextTick(() => {
                    this.$refs['check'].init(id);
                })
            },
            lookFamily(id){
                this.familyVisible = true;
                this.$nextTick(() => {
                    this.$refs['family'].init(id);
                })
            },
            importUser(){
                this.importUserVisible = true;
                this.$nextTick(() => {
                    this.$refs['importUser'].init();
                })    
            },
            lookVideo(row){
                this.uploadVideoVisible = true;
                this.$nextTick(() => {
                    this.$refs['uploadVideo'].init(row.id);
                })
            },
            exportExcel(){
                let deptIdArr=new Array()
                for(let i=0;i<this.deptId.length;i++){
                    let deptId=this.deptId[i]
                    deptIdArr.push(deptId[deptId.length-1])
                }

                if(deptIdArr.length == 0){
                    this.$commonFn.showTip("请选择机构名称，再进行导出",2)
                    return
                }
                this.exportData()
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url=this.userExportUrl;
                let param = new URLSearchParams();
                
                let deptIdArr=new Array();
                for(let i=0;i<this.deptId.length;i++){
                    let deptId=this.deptId[i];
                    deptIdArr.push(deptId[deptId.length-1]);
                }
                param.append('name', this.name);
                param.append('cardNo', this.cardNo);
                param.append('checkStatus', this.checkStatus);
                param.append('deptId', deptIdArr.join(","));
                param.append('roomNumber', this.roomNumber);
                param.append('classNo', this.classNo);
                param.append('dingTalkBindStatus', this.dingTalkBindStatus);
                param.append('inputFaceYear', this.inputFaceYear);
                param.append('personType', 1);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '学生信息.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error); 
                    this.loading=false;
                });
           },
           downloadQrcode(row){
                this.loading=true;
                this.loadingText="正在下载中，下载过程时间可能会比较长，请耐心等待";

                let url=this.downloadQrcodeUrl;
                let param = new URLSearchParams();
                param.append('userId', row.id);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    let filename= row.name+"("+row.deptIdstrName+")";
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/octet-stream" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download",filename.replace('/','')+'.png');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error); 
                    this.loading=false;
                });
           },
           downloadBatchQrcode(){
                this.loading=true;
                this.loadingText="正在下载中，下载过程时间可能会比较长，请耐心等待";

                let url=this.downloadBatchQrcodeUrl;
                let param = new URLSearchParams();
                let deptIdArr=new Array();
                for(let i=0;i<this.deptId.length;i++){
                    let deptId=this.deptId[i];
                    deptIdArr.push(deptId[deptId.length-1]);
                }
                param.append('isPage', this.common.isPage);
                param.append('page', this.common.page);
                param.append('limit', this.common.pageSize);
                param.append('name', this.name);
                param.append('cardNo', this.cardNo);
                param.append('checkStatus', this.checkStatus);
                param.append('deptId', deptIdArr.join(","));
                param.append('roomNumber', this.roomNumber);
                param.append('personType', 1);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/octet-stream" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download",'学生二维码.zip');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error); 
                    this.loading=false;
                });
            },
            updateDingUnbind(row){
                let tipMsg ="将此学生关联的钉钉号数据清除，家长进入钉钉小程序需要重新绑定学生。适用于学生被错误绑定后，家长不能绑定自己的孩子的情况。是否继续此操作？"
                this.userId = row.id;
                this.$commonFn.showConfirm2(tipMsg,this.updateDingUnbindSuccess);

            },
            updateDingUnbindSuccess(){
                let url = this.userUpdateDingUnbindUrl
                let data = {
                    userId:this.userId
                };
                this.apiPost(url,data).then((res)=>{
                     this.loading=false
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1)
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                })
            },
            batchDingUnbind(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i] !=1 ){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.userId= idStr;

                    let msg="将选中人员关联的钉钉号数据清除，是否继续此操作？";
                    this.$commonFn.showConfirm2(msg,this.batchDingUnbindSuccess);
                }else{
                    this.$commonFn.showTip("请选择数据",2);
                }
            },
            batchDingUnbindSuccess(){
                let url = this.userBatchDingUnbindUrl
                let data = {
                    userIds:this.userId
                };
                this.apiPost(url,data).then((res)=>{
                     this.loading=false;
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1)
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                })
            },
            permissionControl(row){
                let classId=row.deptIdstr;
                let name=row.name;
                if(this.currUserId == '1'){
                    return true;
                }else{
                    // 校长
                    if(this.headmaster == this.currUserId){
                        return true;
                    }
                    // 人员编辑权限
                    if(this.$util.isNotEmpty(this.selfDeptId)){
                        let selfDeptIdArr=this.selfDeptId.split(',');
                        for(let i=0;i<selfDeptIdArr.length;i++){
                            console.log('姓名：'+name+'，绑定的部门ID：'+classId);
                            console.log('负责的部门ID：'+selfDeptIdArr[i]);
                            if(classId == null){
                                continue;
                            }
                            if(classId.indexOf(selfDeptIdArr[i])>-1){
                                return true;
                            }
                        }
                    }

                    // 班主任
                    if(this.classTearcher == this.currUserId){
                        let teachingClassArr=this.controlClass.split(',');
                        for(let i=0;i<teachingClassArr.length;i++){
                            console.log('姓名：'+name+'，绑定的部门ID：'+classId);
                            console.log('负责的部门ID：'+teachingClassArr[i]);
                            if(classId == null){
                                continue;
                            }
                            console.log(classId.indexOf(teachingClassArr[i]))
                            if(classId.indexOf(teachingClassArr[i])>-1){
                                return true;
                            }
                        }
                    }
                    return false;
                }
            },
            isInputFace(inputFaceYear, updateFaceImageTime){
                if(inputFaceYear == null){
                    return '是'
                }
                
                if(inputFaceYear < 1){
                    return '否'
                }else{
                    return '是(更新人脸时间:'+updateFaceImageTime+')'
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     
</style>




// WEBPACK FOOTER //
// src/components/page/sys/student/Student.vue